module.exports = __webpack_public_path__ + "assets/img/list-moreBtn-en.5c256a4e.png";